<template>
  <div class="">
     <div class="top-search-box">
      <topTab :rout="rout"></topTab>
    </div>
    <div class="content">
    <img class="page-logo" src="@/assets/home/6.png" alt="" />

    <div class="title">
      <div class="title-line"></div>
      <span>手机号码测算</span>
    </div>
    <div class="text">
      <p>
        万物皆有数理,号码者，手机号码测算,万物皆有数理,号码者，数也。手机号码,其实暗藏着出生地域及生日信息,自然包括很多命运密码。
      </p>
    </div>

    <div class="input-box">
      <i class="iconfont icon-shouji"></i>
      <input type="number" v-model="phone" placeholder="请输入手机号码" />
    </div>

    <div style="height: 3rem"></div>
    <div class="start-btn" @click="start">开始测算</div>
    <shareBottomComp v-if="share == 1"></shareBottomComp>
</div>
  </div>
</template>

<script>
/**
@description:号码吉凶
@createTime:2021-08-26
@create:wq
*/
import topTab from "@/components/topTab";

import shareBottomComp from '@/components/shareBottomComp'
import { shareJsSdk,HERF, getQueryString } from "@/utils/tool";
export default {
  name: "",
  props: {},
  components: {shareBottomComp,topTab},
  data() {
    return {
      phone: "",
      share:0,
      rout:[{
        name:'首页',
        path:'/home'
      },{
        name:'号码吉凶',
        path:'/numjx'
      }]
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    if (getQueryString("share")) {
      this.share = 1;
    }else{
      this.share = 0
    }
    shareJsSdk('numjx','号码吉凶','','',HERF+'/image/6.png')
  },
  methods: {
    start() {
      if (this.phone === "") return this.Toast("请输入手机号");
      this.api.numberBadLuck({ phone: this.phone }).then((res) => {
        localStorage.setItem("result", JSON.stringify(res.data));
        this.$router.push("numjxres");
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  overflow: hidden;
  margin: 0 0.24rem;
}
.page-logo {
  width: 1.2rem;
  /* height: 1.2rem; */
  display: block;
  margin: 0.76rem auto;
}
.title {
  display: flex;
  align-items: center;

  font-size: 0.3rem;
  font-weight: 400;
  color: #f9647d;
  .title-line {
    width: 0.08rem;
    height: 0.34rem;
    background: linear-gradient(180deg, #4fd9d5 0%, #2fb1ad 100%);
    border-radius: 0px 0.04rem 0.04rem 0px;
    margin-right: 0.1rem;
  }
}
.text {
  margin-top: 0.24rem;
  font-size: 0.24rem;
  font-weight: 400;
  color: #666666;
  p {
    text-indent: 2em;
  }
}
.sex {
  //   padding: 0 0.34rem;
  margin: 1rem 0 0.46rem;
  height: 0.8rem;
  border-radius: 0.4rem;
  box-sizing: border-box;
  background: #f0f0f0;
  overflow: hidden;

  font-size: 0.3rem;
  font-weight: 400;
  color: #666666;
  display: flex;
  > div {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .action {
    color: #ffffff;
    background: #4fd9d5;
  }
}
.select-time {
  margin: 0.26rem 0;
  display: flex;
  align-items: center;
  > span {
    font-size: 0.3rem;
    font-weight: 400;
    color: #666666;
    margin-right: 0.38rem;
  }
  .select-box {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.24rem 0 0.44rem;
    border-radius: 0.5rem;
    background: #f0f0f0;
    border: 1px solid #e6e6e6;
    height: 0.76rem;
    span {
      font-size: 0.24rem;
      font-weight: 500;
      color: #cccccc;
    }
    i {
      font-size: 0.28rem;
      color: #53cedc;
    }
  }
}
.tips {
  margin-top: 0.7rem;
  display: flex;
  font-size: 0.24rem;
  font-weight: 400;
  color: #999999;
}

.start-btn {
  width: 7rem;
  height: 0.88rem;
  background: #4fd9d5;
  border-radius: 0.54rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 1.2rem;
  left: 50%;
  transform: translateX(-50%);

  font-size: 0.3rem;
  font-weight: 400;
  color: #ffffff;
}
.input-box {
  height: 1rem;
  border-radius: 0.5rem;
  background: #f0f0f0;
  border: 1px solid #e6e6e6;
  display: flex;
  align-items: center;
  padding: 0 0.44rem;
  margin-top: 0.5rem;
  input {
    border: none;
    background: transparent;
    height: 100%;
    font-size: 0.3rem;
    flex: 1;
  }

  i {
    margin-right: 0.2rem;
    color: #cccccc;
    font-size: 0.4rem;
  }
}
</style>
